import { AxiosError } from "axios";
import { useMutation, useQuery, UseQueryOptions } from "react-query";
import HttpService from "../../services/http";
import { toast } from "react-toastify";
import { UniversalCacheManager } from "../../utils/cacheManager";

const authCache = new UniversalCacheManager();

export const useGetPasswordLevel = (
  options?: UseQueryOptions<any, AxiosError<any, any>, any, [string]>
) => {
  return useQuery(
    ["password-levels"],
    async () => {
      const cacheKey = `auth_password_levels`;
      const cached = authCache.get(cacheKey);

      if (cached) {
        return cached;
      }

      const res = await HttpService.get("/auth/password-levels");

      const data = res?.data?.element;
      authCache.setWithLongTTL(cacheKey, data);
      return data;
    },
    {
      onError: (err) => {
        toast.error(err.response?.data?.message || err.message);
      },
      ...options,
    }
  );
};

export const useCheckPassword = () => {
  return useMutation<any, AxiosError<any, any>, any>(
    (data: any) => HttpService.post("/auth/check-password", data),
    {
      onSuccess: (data) => {},
      onError: (err) => {
        toast.error(err.response?.data?.message || err.message);
      },
    }
  );
};
